export default "__VITE_ASSET__608318d8__"